"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
/**
 * Reads context parameter JSON from the window local storage and deserializes it
 * @returns ContextParams
 */
var contextParamsFromLocalStorage = function () {
    // check if local storage is available
    if (!(window === null || window === void 0 ? void 0 : window.localStorage))
        return {};
    // read from context param key
    var contextParamsJson = window.localStorage.getItem(constants_1.CONTEXT_PARAMS_LOCAL_STORAGE_KEY);
    if (!contextParamsJson)
        return {};
    // parse JSON
    try {
        return JSON.parse(contextParamsJson);
    }
    catch (e) {
        return {};
    }
};
exports.default = contextParamsFromLocalStorage;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/API/GraphApi/contextParams/contextParamsFromLocalStorage.js
// module id = 3372
// module chunks = 11